import { FC } from 'react';
import { CostAndTimeTable } from './CostAndTimeTable/CostAndTimeTable';

import styles from '../LandingPage.module.scss';

export const COST_AND_TIME_INFO_POSITION_ABOVE_VERTICALFAQ = 'AboveVerticalFAQ';

export const COST_AND_TIME_INFO_POSITION_ABOVE_FINDPROGROUP = 'AboveFindProGroup';

export const COST_AND_TIME_INFO_POSITION_UNDER_SUMMARY = 'BelowSummary';

interface Props {
  CTTableInfo: string;
  costAndTimeInfoPosition: string;
  costAndTimeInfoSummary: string | undefined;
  shouldDisplayCTInfoSummary: boolean | undefined;
}

const CostAndTime: FC<Props> = ({
  CTTableInfo,
  costAndTimeInfoPosition,
  costAndTimeInfoSummary,
  shouldDisplayCTInfoSummary,
}) => (
  <>
    {costAndTimeInfoPosition === COST_AND_TIME_INFO_POSITION_UNDER_SUMMARY && (
      <>
        {shouldDisplayCTInfoSummary && costAndTimeInfoSummary && (
          <div dangerouslySetInnerHTML={{ __html: costAndTimeInfoSummary }} />
        )}
        <CostAndTimeTable CTTableInfo={CTTableInfo} />
      </>
    )}

    {costAndTimeInfoPosition !== COST_AND_TIME_INFO_POSITION_UNDER_SUMMARY && (
      <div className={styles['section']}>
        <div className={styles['content']}>
          {shouldDisplayCTInfoSummary && costAndTimeInfoSummary && (
            <div dangerouslySetInnerHTML={{ __html: costAndTimeInfoSummary }} />
          )}
          <CostAndTimeTable CTTableInfo={CTTableInfo} />
        </div>
      </div>
    )}
  </>
);
export { CostAndTime };
